<script>
    import { res } from './stores.js';
    import { takeTurns } from './turns.js';
    import { pegParse } from './pegparse.js';
    import { parseCardsOld } from './parse.js';
    import JSON5 from 'json5';
    import Mousetrap from 'mousetrap';
    import { get, set } from 'idb-keyval';

    //let importedGrammar = grammar;
    let unparsed = true;
    let selected = false;
    let selectedIndex = -1;
    let deckFilter = false;
    let setFilter = false;
    let text = '';

    parseCardsOld($res.allCards.filter(c => c && $res.parsedCardText[c.id] && $res.parsedCardText[c.id].error));

    function exportPrompt(){
        let cards = $res.allCards.filter(c => !deckFilter || c.deck == deckFilter || deckFilter == 'Bot charts' && c.botCard).filter(c => !setFilter || c.box == setFilter).filter(c => !unparsed || $res.parsedCardText[c.id].response == 'error').sort((a,b) => a.name.localeCompare(b.name));
        let errors = [];
        for(let c of cards){
            let pct = $res.parsedCardText[c.id];
            if(!pct.error || !pct.text) continue;
            errors.push(`Text "${pct.text}" currently produces error "${pct.error}"`);
        }
        let text =
`Plan out the changes to grammar and implementation needed to ensure all the following card effects parse and execute correctly:
${errors.map((e,i) => `\nCard ${i+1}: ${e}`)}`;
        navigator.clipboard.writeText(text);
    }

    function reparse(){
        $res.parsedCardText[selected.id] = pegParse(text);
        console.log($res.parsedCardText[selected.id])
        selected = selected;
    }
    

    async function saveAltered(){
        reparse();
        await set(`cardtext-${selected.id}`, {original: selected.allTextOriginal, new: text});
        selected.allText = text;
    }

    function select(ci){
        if(typeof ci == 'number'){
            selectedIndex = ci;
            let filtered = $res.allCards.filter(c => !deckFilter || c.deck == deckFilter || deckFilter == 'Bot charts' && c.botCard).filter(c => !setFilter || c.box == setFilter).filter(c => !unparsed || $res.parsedCardText[c.id].response == 'error').sort((a,b) => a.name.localeCompare(b.name));
            if(filtered.length < selectedIndex) selectedIndex = 0;
            selected = filtered[selectedIndex];
        }else{
            selected = ci;
            selectedIndex = $res.allCards.filter(c => !deckFilter || c.deck == deckFilter || deckFilter == 'Bot charts' && c.botCard).filter(c => !setFilter || c.box == setFilter).filter(c => !unparsed || $res.parsedCardText[c.id].response == 'error').sort((a,b) => a.name.localeCompare(b.name)).findIndex(c => c == ci);
        }
        text = $res.parsedCardText[selected.id].text;
        console.log(text);
    }

    Mousetrap.bind('down', (e) => {selectedIndex++; if(selectedIndex >= $res.allCards.filter(c => !deckFilter || c.deck == deckFilter || deckFilter == 'Bot charts' && c.botCard).filter(c => !setFilter || c.box == setFilter).filter(c => !unparsed || $res.parsedCardText[c.id].response == 'error').sort((a,b) => a.name.localeCompare(b.name)).length) selectedIndex = 0; select(selectedIndex); e.preventDefault();})
    Mousetrap.bind('up', (e) => {selectedIndex--; if(selectedIndex < 0) selectedIndex = $res.allCards.filter(c => !deckFilter || c.deck == deckFilter || deckFilter == 'Bot charts' && c.botCard).filter(c => !setFilter || c.box == setFilter).filter(c => !unparsed || $res.parsedCardText[c.id].response == 'error').sort((a,b) => a.name.localeCompare(b.name)).length - 1; select(selectedIndex);  e.preventDefault();})
</script>
<div class="whole">
    <div class="half">
        <div style="border-bottom: 1px solid white;">
            <input type="checkbox" bind:checked={unparsed} /> Show only unparsed?
            Filter by deck: 
            <select bind:value={deckFilter}>
                <option value={false}>All decks</option>
                {#each [...Array.from(new Set($res.allCards.filter(c => !unparsed || $res.parsedCardText[c.id].response == 'error').map(c => c.deck).filter(c => c))), 'Bot charts'] as d}
                    <option value={d}>{d} ({$res.allCards.filter(c => (!unparsed || $res.parsedCardText[c.id].response == 'error') && (c.deck == d || d == 'Bot charts' && c.botCard)).length} cards)</option>
                {/each}
            </select>
            Filter by set: 
            <select bind:value={setFilter}>
                <option value={false}>All decks</option>
                {#each Array.from(new Set($res.allCards.filter(c => !unparsed || $res.parsedCardText[c.id].response == 'error').map(c => c.box).filter(c => c))) as d}
                    <option value={d}>{d} ({$res.allCards.filter(c => (!unparsed || $res.parsedCardText[c.id].response == 'error') && c.box == d).length} cards)</option>
                {/each}
            </select>
            <button on:click={exportPrompt}>Copy prompt for cards</button>
        </div>
        <div>
            {$res.allCards.filter(c => !deckFilter || c.deck == deckFilter || deckFilter == 'Bot charts' && c.botCard).filter(c => !setFilter || c.box == setFilter).filter(c => $res.parsedCardText[c.id].response != 'error').length} parsed, 
            {$res.allCards.filter(c => !deckFilter || c.deck == deckFilter || deckFilter == 'Bot charts' && c.botCard).filter(c => !setFilter || c.box == setFilter).filter(c => $res.parsedCardText[c.id].response == 'error').length} unparsed
        </div>
        <div style="height: 100%; width: 100%; overflow: scroll;">
            {#each $res.allCards.filter(c => !deckFilter || c.deck == deckFilter || deckFilter == 'Bot charts' && c.botCard).filter(c => !setFilter || c.box == setFilter).filter(c => !unparsed || $res.parsedCardText[c.id].response == 'error').sort((a,b) => a.name.localeCompare(b.name)) as c, i}
                <div style="cursor: pointer;" class:selected={selected == c} on:click={e => { select(c); } } class:error={$res.parsedCardText[c.id].response == 'error'}>
                    {c.name} ({c.id}):
                    {#if $res.parsedCardText[c.id].effects}Parsed
                    {:else if $res.parsedCardText[c.id].response == 'error'}
                        Error:
                    {/if}
                </div>
            {/each}
        </div>
    </div>
    <div class="half">
        {#if selected && $res.parsedCardText[selected.id]}
            <div class="quarter" style="overflow: scroll;">
                <div style="height: 100%;">
                    <textarea style="width:100%; height: 100%;" bind:value={text}></textarea>
                </div>
            </div>
            <div class="quarter">
                    {#if $res.parsedCardText[selected.id].error}
                        <div style="overflow: auto;" class="error">
                            {$res.parsedCardText[selected.id].error}
                            
                        </div>
                        <div>
                            {$res.parsedCardText[selected.id].text.slice(0, $res.parsedCardText[selected.id].place)}<span class="here">{$res.parsedCardText[selected.id].text[$res.parsedCardText[selected.id].place]}</span>{$res.parsedCardText[selected.id].text.slice($res.parsedCardText[selected.id].place + 1)}
                        </div>
                        <button on:click={e => reparse($res.parsedCardText[selected.id])}>Reparse</button>
                        <button on:click={saveAltered}>Save changes</button>
                    {:else}
                        <div style="white-space: pre; overflow: scroll; max-height: 50%;">
                            {JSON5.stringify($res.parsedCardText[selected.id].response, null, 2)}
                        </div>
                        <button on:click={saveAltered}>Save changes</button>
                    {/if}
                
            </div>
        {/if}
    </div>

</div>
<style>
    .whole {
        min-height: 0;
        display: flex;
        max-height: 75vh;
    }
    .half {
        flex-basis: 50%;
        display: flex;
        flex-direction: column;
        border: 2px solid white;
    }
    .quarter{
        flex-basis: 50%;
        border: 2px solid white;
        display: flex;
        flex-direction: column;
        max-height: 50%;
    }
    .error {
        color: red;
    }

    .selected {
        background-color: orange;
        color: white;
    }
    .here {
        color: white;
        background-color: orange;
    }
</style>